export default "__VITE_ASSET__sU9BxJ05__"